export default "__VITE_ASSET__CCQQ_fXA__"